@solidale.controller 'HeaderCtrl', ['$rootScope', '$scope', '$stateParams', '$location', '$localStorage', 'Auth', 'Data', '$transitions', '$q', '$state', '$timeout', '$cookies', ($rootScope, $scope, $stateParams, $location, $localStorage, Auth, Data, $transitions, $q, $state, $timeout, $cookies) ->
	
	$rootScope.$state = $state

	# =======================	
	# complete, loading
	# =======================

	# loading
	$rootScope.openLoading = ()->
		$rootScope.isloading = true

	$rootScope.closeLoading = ()->
		$rootScope.isloading = false

	# complete	
	$rootScope.completePrompt = ($text)->
		$rootScope.iscomplete = true
		$rootScope.completetext = $text

		$timeout ()->
			$rootScope.iscomplete = false
			$rootScope.completetext = ''
		, 7000
	

	# ================	
	# Authentications
	# =================
	$scope.signup = 
		usr: ''
		email: ''
		pwd: ''

	$scope.signin = 
		email: ''
		pwd: ''
		remember: false

	$scope.forgot =
		email: ''

	$scope.error = 
		signin: 
			input: false
			log: false
		signup:
			input: false
			pwdlength: false
			already: false
		forgot:
			input: false
			noexist: false

	$checkSignInInput = ()->
		defer = $q.defer()

		$isError = false

		# 1. ini
		$scope.error.signin = 
			input: false
			log: false

		# 2. check		
		angular.forEach $scope.signin, (v, k) ->
			if v.length < 1
				$scope.error.signin.input = true
				$isError = true

		defer.resolve $isError
		defer.promise


	$checkSignUpInput = ()->
		defer = $q.defer()

		$isError = false

		# 1. ini
		$scope.error.signup =
			input: false
			pwdlength: false
			already: false

		# 2. check		
		angular.forEach $scope.signup, (v, k) ->
			if v.length < 1
				$scope.error.signup.input = true
				$isError = true
			
			if angular.equals(k, 'pwd') && v.length < 8
				$scope.error.signup.pwdlength = true
				$isError = true

		defer.resolve $isError
		defer.promise


	$checkForgotInput = ()->
		defer = $q.defer()

		$isError = false

		# 1. ini
		$scope.error.forgot =
			input: false
			noexist: false

		# 2. check		
		if $scope.forgot.email.length < 1
			$scope.error.forgot.input = true
			$isError = true

		defer.resolve $isError
		defer.promise	

	# Get Auth
	# ==========
	signinSuccessAuth = (res) ->
		$localStorage.token = res.token

		$timeout ()->
			$rootScope.completePrompt('ログイン完成')
		, 1000

		$timeout ()->
			window.location = '/'
		, 3000

	signupSuccessAuth = (res) ->
		$localStorage.token = res.token

		$timeout ()->
			$rootScope.completePrompt('登録完成')
		, 1000

		$timeout ()->
			window.location = '/'
		, 5000

	forgotSendSuccess = (res)->
		$timeout ()->
			$rootScope.closeLoading()
			$rootScope.completePrompt('認証メールを送りました')

			$scope.error.forgot.noexist = false
		, 1000

	$scope.signinClick = () ->

		$checkSignInInput().then (isError)->
			if !isError
				formData = 
					email: $scope.signin.email
					password: $scope.signin.pwd
					remember: $scope.signin.remember

				Auth.signin(formData, signinSuccessAuth, () ->
					$scope.error.signin.log = true
				)

	$scope.signupClick = () ->

		$checkSignUpInput().then (isError)->
			if !isError
				formData = 
					name: $scope.signup.usr
					email: $scope.signup.email
					password: $scope.signup.pwd

				Auth.signup(formData, signupSuccessAuth, () ->
					$scope.error.signup.already = true
				)

	$scope.logoutClick = () ->
		Auth.logout(() ->
			$scope.logClose()
			$timeout ()->
				window.location = '/'
			, 500
		)

	$scope.forgotClick = ()->
		formData = 
			email: $scope.forgot.email
		
		$checkForgotInput().then (isError)->
			if !isError
				$rootScope.openLoading()

				Auth.forgot(formData, forgotSendSuccess, () ->
					$timeout ()->
						$rootScope.closeLoading()
						$scope.error.forgot.noexist = true
					, 1000	
				)
					


	# Sidemenu - login
	# =====================
	$scope.isRightNavShow = false
	$scope.logOpen = ()->
		$scope.isRightNavShow = true

	$rootScope.logClose = () ->
		$scope.isRightNavShow = false

	# login / logout switch	
	$scope.rightNavIndex = 1	
	$scope.rightNavSwitch = (ind) ->
		$scope.rightNavIndex = ind

	$rootScope.toSignUp = () ->
		$scope.logOpen()
		$scope.rightNavIndex = 2


	# sidemenu - function
	# =======================
	$scope.isRightMenuShow = false
	$scope.functionOpen = ()->
		$scope.isRightMenuShow = true

	$rootScope.functionClose = () ->
		$scope.isRightMenuShow = false

		
	# Close all side menus
	# ====================	
	$scope.closeAllSidemenu = ()->
		$rootScope.logClose()
		$rootScope.functionClose()

	$rootScope.$on '$locationChangeSuccess', () ->	
		$scope.closeAllSidemenu()


]